import React, { useCallback } from 'react';

import {
  Box,
  useTheme,
  useToast as useChakraToast,
  UseToastOptions,
} from '@chakra-ui/react';

export const useToast = () => {
  const toast = useChakraToast();
  const theme = useTheme();

  const customToast = useCallback(
    (
      message: string | React.ReactNode,
      type: 'success' | 'error',
      params?: UseToastOptions,
    ) => {
      toast({
        position: 'top',
        isClosable: true,
        duration: 3000,
        ...params,
        render: () => (
          <Box
            bg={
              type === 'success'
                ? theme.colors.poisonGreen
                : theme.colors.errorRed
            }
            color={theme.colors.absoluteWhite}
            fontWeight='bold'
            p={3}
          >
            {message}
          </Box>
        ),
      });
    },
    [
      theme.colors.absoluteWhite,
      theme.colors.errorRed,
      theme.colors.poisonGreen,
      toast,
    ],
  );

  return customToast;
};
